import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import { PARSER_WEB_HOTELIER_TOKEN_MUTATION } from '@app/model/integration/service/IntegrationGraphQLQueries';
import WebhotelierOutput from '@app/model/integration/WebhotelierOutput';

class IntegrationService {
	public static parseWebhotelierToken(token: string, htlCode: string) {
		return GraphQLExecutor.execute<WebhotelierOutput>(PARSER_WEB_HOTELIER_TOKEN_MUTATION, {token, htlCode});
	}
}

export default IntegrationService;